import { translate } from '../../i18n';
import InlineErrorState from '../../components/states/InlineErrorState';
import { READ_FAILED_I18N_KEY } from './readState';

/**
 * What a PAGE renders when the elevated-admin check did not come back.
 *
 * The surfaces gated on elevation are settings cards, and their correct render
 * for a real `false` is to not exist — an ordinary operator should not see a
 * platform-admin lever at all. That makes silence the right answer for a
 * DENIAL and the wrong answer for an UNKNOWN, and the two were
 * indistinguishable because every consumer read `data` off the query and
 * branched on `!isElevatedAdmin` (see `classifyElevation`).
 *
 * The notice goes on the PAGE rather than in each card, and that is the whole
 * reason this component exists instead of four in-card error arms.
 * `OrganizationPage` mounts three elevation-gated children; four independent
 * notices would tell the operator the same thing four times, which is its own
 * kind of dishonesty about how much is wrong. One sentence per page says the
 * true thing once: part of this page is missing and we do not know whether you
 * should be seeing it.
 *
 * The cards themselves are unchanged in behaviour and stay FAIL-CLOSED — an
 * unknown elevation grants nothing, here or anywhere. This component only
 * removes the silence around that.
 *
 * `InlineErrorState` is reused rather than re-styled (D59): it is the
 * dashboard's compact in-flow "we do not know what is there" notice, and it
 * already carries the design-system decision. The string is a BORROWED key —
 * `src/i18n/{en,fr}.ts` sit inside the open-PR fence (R96-7), so
 * `READ_FAILED_I18N_KEY` (`common.unexpected_error`, translated in both
 * catalogues) is used rather than a new `organization.elevation_unknown`.
 * When the freeze lifts, that is one edit in `readState.ts`.
 */
export default function ElevationUnknownNotice() {
    return <InlineErrorState message={translate(READ_FAILED_I18N_KEY as any)} />;
}
